const initialState = {
    health_nomination: JSON.parse(localStorage.getItem('health_nomination')) || null,
};

const healthNominationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_HEALTH_NOMINATION':
            return {
                ...state,
                health_nomination: action.payload,
            };
        default:
            return state;
    }
};

export default healthNominationReducer;